module.exports = __webpack_public_path__ + "img/whats_bg.02abbc7c.jpg";